module.exports = __webpack_public_path__ + "img/nav_4.e53db11f.png";